<!--
グラフ出力画面(うみログ向け)
URL：/graph/umilog
-->

<template>
  <div>
    <v-container v-show="this.$parent.dispFlag.graph">
      <alert :errors="errors" css_class="ma-1"></alert>
      <v-tabs
        v-model="tabIndex"
        centered
        color="white"
        center-active
        active-class="tab-active"
      >
        <v-tabs-slider color="transparent"></v-tabs-slider>
        <v-tab
          class="tab-item"
          style="width: 0px; padding: 0px; min-width: 0px"
        />
        <v-tab
          class="tab-item"
          style="font-size: 16pt"
          v-for="item in tabItems"
          :key="item.key"
          @click.stop="item.callback"
        >
          {{ item.label }}
          <span v-if="item.notice" class="notice">！</span>
        </v-tab>
      </v-tabs>
      <v-row v-if="this.$parent.dispFlag.average" justify="center" class="detail-area" style="text-align: right; margin-top: 10px">
        <v-col cols="auto" style="padding: 0px; width: 470px">
          <p style="font-size: 20px; margin: 0px">{{ detailData }}</p>
        </v-col>
      </v-row>
      <v-row justify="center" style="text-align: center; margin-top: 10px">
        <v-col
          cols="auto"
          style="display: flex; align-items: center; padding: 10px"
        >
          <v-card elevation="0" class="ma-4; overflow-x-auto" outlined>
            <v-card-text>
              <v-row>
                <v-col cols="auto" style="width: 470px; margin-right: 20px">
                  <GChart
                    :type="chartType"
                    :data="chartData"
                    :options="chartOptions"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="this.$parent.dispFlag.average" justify="center" class="detail-area" style="text-align: right;margin-top: 5px">
        <v-col cols="auto" style="padding: 0px; width: 470px; color: red">
          <p style="font-size: 14px; margin: 0px">{{ annotateData }}</p>
        </v-col>
      </v-row>
      <v-row v-show="this.$parent.dispFlag.observation == 1 || this.$parent.dispFlag.observation == 2"
        justify="center"
        style="text-align: center; margin-top: 10px"
      >
        <v-col cols="auto" style="padding: 0px; width: 1000px">
          <month-picker-graph
            ref="month_picker_graph"
            @on-select-calendar-month="onSelectCalenderMonth"
          ></month-picker-graph>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MonthPickerGraph from "../graph-sub-contents/month-picker-graph.vue";
import { GChart } from "vue-google-charts/legacy";
import Alert from "../common/alert.vue";
import DateWrapper from "../../logic/common/date-wrapper";

export default {
  components: {
    "month-picker-graph": MonthPickerGraph,
    GChart,
    alert: Alert,
  },
  data() {
    // 表示年1
    this.dispYear1 = "";
    // 表示年2
    this.dispYear2 = "";
    // API取得集計データ
    this.summary_data = [];
    // グラフ種別
    this.chartType = "";
    // グラフデータ
    this.chartData = [];
    // グラフデータ保存用
    this.chartDataRsv = [];

    // グラフ表示オプションの初期化
    this.resetChartOptions();

    // 詳細情報
    this.annotateData = "";
    this.detailData = "";

    // 週別選択月保持用
    this.selectMonthRsv = "0";

    // 月別日数
    this.dayInMonth = [0, 31,29,31,30,31,30,31,31,30,31,30,31];

    return {
      // 表示データ(グラフの種類)
      graphKindName : "",
      // エラー情報初期化
      errors: [],
      // グラフ表示オプション設定値反映
      chartOptions: this.chartOptions,
      // 表層ボタン選択状態
      tabIndex: 1,
      // グラフデータ
      chartData: [],
    };
  },
  methods: {
    /**
     * カレンダーで選択した月に対してグラフ出力する
     */
    onSelectCalenderMonth(selectMonth) {

      // 選択月を保持
      this.selectMonthRsv = Number(selectMonth.substring(5, 7)).toString().padStart(2, "0");

      this.dispGraphData(Number(selectMonth.substring(5, 7)).toString());
    },

    /**
     * グラフ表示オプションの初期化
     */
    resetChartOptions() {
      this.chartOptions = {
        // グラフ表示枠の幅(初期値)
        width: 0,
        // グラフ表示枠の高さ
        height: 0,
        // グラフ表示枠の左端からの有効位置(px)と領域使用率
        chartArea: {
          left: 85,
          width: "100%",
        },
        bar: {
          // グラフ棒各幅を100%に設定
          groupWidth: "100%",
        },
        // 凡例の表示位置(下部)の設定
        legend: {
          position: "bottom",
        },
      };
    },

    /**
     * 選択したページ番号に対応するグラフを出力する
     */
    dispGraphData(selectMonth) {
      var chartDataSub = [];

      // ヘッダ情報を設定
      chartDataSub.push(this.chartDataRsv[0]);

      var startMonth = (Number(selectMonth) - 2) < 0 ? 0: Number(selectMonth) - 2;
      var endMonth = (Number(selectMonth) + 1) > 12 ? 12: Number(selectMonth) + 1;
      const startIdx = this.getDayOfYear(new Date(this.dispYear1, startMonth, 1));
      const endIdx = this.getDayOfYear(new Date(this.dispYear1, endMonth, 0));
      for (let i = startIdx; i <= endIdx; i++) {
        // 表示年1、表示年2のどちらもうるう年でない場合は2月29日のデータをスキップする
        if (!this.isLeapYear(this.dispYear1) && !this.isLeapYear(this.dispYear2) && i == 60) {
          continue;
        }
        chartDataSub.push(this.chartDataRsv[i]);
      }

      // データチェックしてグラフオブジェクトに表示データ設定
      const checkedChartData = this.checkArray(chartDataSub);
      if (this.graphKindName == "日平均溶存酸素の推移") {
        this.chartData = this.convertDissolvedOxygenTooltipData(checkedChartData);
      } else {
        this.chartData = checkedChartData;
      }
    },
    /**
     * 溶存酸素グラフのtooltip表示を4〜6系列のみに制御する
     */
    convertDissolvedOxygenTooltipData(chartArr) {
      if (!chartArr || chartArr.length === 0) {
        return chartArr;
      }

      const header = chartArr[0];
      const unit = " mg/L";
      const converted = [[
        header[0],
        { type: "string", role: "tooltip" },
        header[1],
        header[2],
        header[3],
        header[4],
        header[5],
        header[6],
        header[7],
      ]];

      for (let i = 1; i < chartArr.length; i++) {
        const row = chartArr[i];
        const toLabel = (value, label) => {
          if (value == null || Number.isNaN(Number(value))) {
            return null;
          }
          return label + ": " + Number(value).toFixed(1) + unit;
        };

        const tooltipItems = [
          row[0] != null ? "日付: " + row[0] : null,
          toLabel(row[5], header[5]),
          toLabel(row[6], header[6]),
          toLabel(row[7], header[7]),
        ].filter((item) => item != null);

        const categoryTooltip = tooltipItems.length > 0 ? tooltipItems.join("\n") : null;

        converted.push([
          row[0],
          categoryTooltip,
          row[1],
          row[2],
          row[3],
          row[4],
          row[5],
          row[6],
          row[7],
        ]);
      }

      return converted;
    },
    /**
     * グラフ表示用データを設定する
     */
    setOutputData(
      graphKindName,
      dispYear1,
      dispYear2,
      summary_data,
    ) {
      this.graphKindName = graphKindName;
      this.dispYear1 = dispYear1;
      this.dispYear2 = dispYear2;
      this.summary_data = summary_data;

      // 出力メッセージ領域クリア
      this.$parent.clearMessage();

      // グラフ情報設定
      this.setChartSettings();

      // グラフデータを生成
      this.chartDataRsv = this.genarateGraphData(this.summary_data);

      // グラフデータを整形してGoogle Chartオブジェクトに設定
      this.setGraphObject(this.chartDataRsv);
    },
    /**
     * グラフ出力(表層)
     */
    surfaceOutput() {
      // 表層ボタン選択状態
      this.tabIndex = 1;

      this.setOutputData(
        this.graphKindName,
        this.dispYear1,
        this.dispYear2,
        this.summary_data,
      );
    },
    /**
     * グラフ出力(中層)
     */
    middleOutput() {
      // 中層ボタン選択状態
      this.tabIndex = 2;

      this.setOutputData(
        this.graphKindName,
        this.dispYear1,
        this.dispYear2,
        this.summary_data,
      );
    },
    /**
     * グラフ出力(深層)
     */
    deepOutput() {
      // 深層ボタン選択状態
      this.tabIndex = 3;

      this.setOutputData(
        this.graphKindName,
        this.dispYear1,
        this.dispYear2,
        this.summary_data,
      );
    },
    /**
     * 深さ別キー設定
     */
    getTabItems() {
      let items = [];
      //表示データがクロロフィルの場合は、表層(1m)のみ表示しかし、ラベル名は中層(5m)
      //表示データが塩分の場合は、表層(1m)のみ表示
      //表示データが溶存酸素の場合は、深層(10m)のみ表示
      switch (this.graphKindName) {
        case "日平均クロロフィルの推移":
          items.push({
            label: "中層(5m)",
            key: "1",
            callback: () => this.surfaceOutput(),
          });
          break;
        case "日平均塩分の推移":
          items.push({
            label: "表層(1m)",
            key: "1",
            callback: () => this.surfaceOutput(),
          });
          break;
        case "日平均溶存酸素の推移":
          items.push({
            label: "深層(10m)",
            key: "1",
            callback: () => this.surfaceOutput(),
          });
          break;
        default:
          items.push({
            label: "表層(1m)",
            key: "1",
            callback: () => this.surfaceOutput(),
          });
          items.push({
            label: "中層(5m)",
            key: "2",
            callback: () => this.middleOutput(),
          });
          items.push({
            label: "深層(10m)",
            key: "3",
            callback: () => this.deepOutput(),
          });
          break;
      }
      return items;
    },
    /**
     * グラフの設定を行う
     */
    setChartSettings() {
      // グラフの種類設定
      this.chartType = "LineChart";
      // グラフの横幅設定
      this.chartOptions.width = 420;
      // グラフの高さ設定
      this.chartOptions.height = 350;
      // グラフ表示枠の左端からの有効位置(px)と領域使用率
      this.chartOptions.chartArea = {
        left: 85,
        width: "100%",
      };
      // グラフ棒各幅設定
      this.chartOptions.bar = {
        groupWidth: "80%",
      };
      // 左右のY軸表示の設定
      this.chartOptions.vAxis = {
        title: "",
        titleTextStyle: { italic: false },
      };
      // フォーカスターゲットをカテゴリに設定
      this.chartOptions.focusTarget = 'category';

      // 型定義、カラー、凡例位置、表示行数、テキストスタイル
      this.chartOptions.series = {
        0: { type: "number" },
        1: { type: "number" },
        2: { type: "number", lineDashStyle: [3, 3] },
        3: { type: "number", lineDashStyle: [3, 3] },
      };

      this.chartOptions.legend = {position:'bottom', textStyle: {fontSize: 14}};

      switch (this.graphKindName) {
        case "日平均水温の推移":
          this.chartOptions.vAxis = {
            title: "[℃]",
            titleTextStyle: { italic: false },
          };

          this.chartOptions.legend = {position:'top', maxLines: 2, textStyle: {fontSize: 14}};
          break;
        case "日平均クロロフィルの推移":
          this.chartOptions.vAxis = {
            title: "[ppb]",
            titleTextStyle: { italic: false },
          };

          this.chartOptions.series = {
            0: { type: "number" },
            1: { type: "number", lineDashStyle: [3, 3] },
            2: { type: "number", lineDashStyle: [3, 3] },
            3: { type: "number", color: "gray" },
            4: { type: "number", color: "red" },
          };

          this.chartOptions.legend = {position:'top', maxLines: 2, textStyle: {fontSize: 14}};
          break;
        case "日平均塩分の推移":
          this.chartOptions.vAxis = {
            title: "[psu]",
            titleTextStyle: { italic: false },
          };

          this.chartOptions.series = {
            0: { type: "number" },
            1: { type: "number", lineDashStyle: [3, 3] },
            2: { type: "number", lineDashStyle: [3, 3] },
          };
          break;
        case "日平均溶存酸素の推移":
          // 背景バンドを面で表現するため ComboChart を使用
          this.chartType = "ComboChart";

          // Y軸上限は genarateGraphData() でデータに応じて動的に設定される(最小12)
          this.chartOptions.vAxis = {
            title: "[mg/L]",
            titleTextStyle: { italic: false },
            viewWindow: { min: 0, max: 12 },
          };

          // ComboChart のデフォルト系列タイプは線
          this.chartOptions.seriesType = "line";

          // 列の並び(月日 + 7系列)
          //  0: 緑 area(20)   · "6.0 mg/L以上"
          //  1: 黄 area(6.0)  · "4.3～6.0 mg/L"
          //  2: 赤 area(4.3)  · "2.0～4.3 mg/L"
          //  3: グレー area(2.0) · "2.0 mg/L未満"
          //  4: 日平均 line
          //  5: 過去最高 dashed line
          //  6: 過去最低 dashed line
          this.chartOptions.series = {
            0: { type: "area", color: "#66BB6A", areaOpacity: 0.35, lineWidth: 0, pointSize: 0, enableInteractivity: false },
            1: { type: "area", color: "#FFEB3B", areaOpacity: 0.35, lineWidth: 0, pointSize: 0, enableInteractivity: false },
            2: { type: "area", color: "#EF9A9A", areaOpacity: 0.45, lineWidth: 0, pointSize: 0, enableInteractivity: false },
            3: { type: "area", color: "#BDBDBD", areaOpacity: 0.45, lineWidth: 0, pointSize: 0, enableInteractivity: false },
            4: { type: "line", color: "#1E88E5" },
            5: { type: "line", lineDashStyle: [3, 3] },
            6: { type: "line", lineDashStyle: [3, 3] },
          };

          this.chartOptions.legend = {position:'top', maxLines: 3, textStyle: {fontSize: 12}};
          break;
        case "積算水温の表示":
          this.chartOptions.vAxis = {
            title: "[℃]",
            titleTextStyle: { italic: false },
          };

          switch (this.tabIndex) {
            case 1:
            default:
              this.chartOptions.series = {
                0: { type: "number", color: "#00D7FF" },
                1: { type: "number", color: "#00D7FF", lineDashStyle: [3, 3] },
                2: { type: "number", color: "#FF0000" },
              };
              break;
            case 2:
              this.chartOptions.series = {
                0: { type: "number", color: "#00FF00" },
                1: { type: "number", color: "#00FF00", lineDashStyle: [3, 3] },
                2: { type: "number", color: "#FF0000" },
              };
              break;
            case 3:
              this.chartOptions.series = {
                0: { type: "number", color: "#FD7E00" },
                1: { type: "number", color: "#FD7E00", lineDashStyle: [3, 3] },
                2: { type: "number", color: "#FF0000" },
              };
              break;
          }
  
          break;
        case "20℃超過日数の表示":
          this.chartOptions.vAxis = {
            title: "[日]",
            titleTextStyle: { italic: false },
          };

          this.chartOptions.series = {
            0: { type: "number", color: "blue" },
            1: { type: "number", color: "red" },
          };
  
          break;
        default:
          break;
      }
    },
    /**
     * グラフデータの初期設定を行う
     */
    initChartData() {

      var chartData = [];

      // 凡例ラベル設定(R:令和)
      if (this.summary_data.length > 0) {
        var annotation1 = "R" + (this.dispYear1 - 2018);
        var annotation2 = "R" + (this.dispYear2 - 2018);
      }

      // 情報設定(ヘッダ情報をセットする)
      switch (this.graphKindName) {
        case "日平均水温の推移":
          chartData.push([
            "月日",
            annotation1 + "日平均",
            "平年値",
            "過去最高",
            "過去最低",
          ]);
          break;
        case "日平均クロロフィルの推移":
          chartData.push([
            "月日",
            annotation1 + "日平均",
            "過去最高",
            "過去最低",
            "基準値2",
            "基準値4",
          ]);
          break;
        case "日平均塩分の推移":
          chartData.push([
            "月日",
            annotation1 + "日平均",
            "過去最高",
            "過去最低",
          ]);
          break;
        case "日平均溶存酸素の推移":
          chartData.push([
            "月日",
            "6.0 mg/L以上",
            "4.3～6.0 mg/L",
            "2.0～4.3 mg/L",
            "2.0 mg/L未満",
            annotation1 + "日平均",
            "過去最高",
            "過去最低",
          ]);
          break;
        case "積算水温の表示":
          annotation2 = "R" + (this.dispYear1 - 1 - 2018);
          chartData.push([
            "月日",
            annotation1 + "水温",
            annotation2 + "水温",
            "基準線",
          ]);
          break;
        case "20℃超過日数の表示":
          annotation2 = "R" + (this.dispYear1 - 1 - 2018);
          chartData.push([
            "月日",
            "日数",
            "基準線",
          ]);
          break;
        default:
          break;
      }

      for (let m = 1; m <= 12; m++) {
        for (let d = 1; d <= this.dayInMonth[m]; d++) {
          switch (this.graphKindName) {
            case "日平均水温の推移":
              chartData.push([m.toString() + "月" + d.toString() + "日", 0, 0, 0, 0]);
              break;
            case "日平均クロロフィルの推移":
              chartData.push([m.toString() + "月" + d.toString() + "日", 0, 0, 0, 0, 0]);
              break;
            case "日平均塩分の推移":
            case "積算水温の表示":
              chartData.push([m.toString() + "月" + d.toString() + "日", 0, 0, 0]);
              break;
            case "日平均溶存酸素の推移":
              // 月日 + (緑・黄・赤・グレーバンド) + (日平均・過去最高・過去最低)
              chartData.push([m.toString() + "月" + d.toString() + "日", 0, 0, 0, 0, 0, 0, 0]);
              break;
            case "20℃超過日数の表示":
              chartData.push([m.toString() + "月" + d.toString() + "日", 0, 0]);
              break;
            default:
              break;
          }
        }
      }

      return chartData;
    },
    /**
     * グラフデータを生成する
     */
    genarateGraphData(summaryData) {

      var index = 0;
      var dataTemp = [];

      // グラフデータ配列初期化
      var chartArr = this.initChartData();

      switch (this.graphKindName) {
        case "日平均水温の推移":
          // グラフデータ設定(表示年1)
          if (summaryData[0].length > 0) {
            for (let row of summaryData[0]) {
              index = this.getDayOfYear(new Date(row['date']));
              if (index == 0) continue;
              chartArr[index][1] = this.getOptimalData(row);
            }
          }

          // グラフデータ設定(平年値)
          if (summaryData[3].length > 0) {
            for (let row of summaryData[3]) {
              if (row['date'] != '00/00') {
                dataTemp = row['date'].split('/');
                index = this.getDayOfYear(new Date(this.dispYear1, dataTemp[0] - 1, dataTemp[1]));
                if (index == 0) continue;
                chartArr[index][2] = this.getOptimalWatarTemp(row);
              }
            }
          }

          // グラフデータ設定(過去最高・過去最低)
          if (summaryData[2].length > 0) {
            for (let row of summaryData[2]) {
              if (row['date'] != '00/00') {
                dataTemp = row['date'].split('/');
                index = this.getDayOfYear(new Date(this.dispYear1, dataTemp[0] - 1, dataTemp[1]));
                if (index == 0) continue;
                dataTemp = this.getOptimalAlltimeData(row);
                chartArr[index][3] = dataTemp[0];
                chartArr[index][4] = dataTemp[1];
              }
            }
          }
          break;
        case "日平均クロロフィルの推移":
        case "日平均塩分の推移":
          // グラフデータ設定(表示年1)
          if (summaryData[0].length > 0) {
            for (let row of summaryData[0]) {
              index = this.getDayOfYear(new Date(row['date']));
              if (index == 0) continue;
              chartArr[index][1] = this.getOptimalData(row);
            }
          }

          // グラフデータ設定(過去最高・過去最低)
          if (summaryData[2].length > 0) {
            for (let row of summaryData[2]) {
              if (row['date'] != '00/00') {
                dataTemp = row['date'].split('/');
                index = this.getDayOfYear(new Date(this.dispYear1, dataTemp[0] - 1, dataTemp[1]));
                if (index == 0) continue;
                dataTemp = this.getOptimalAlltimeData(row);
                chartArr[index][2] = dataTemp[0];
                chartArr[index][3] = dataTemp[1];
              }
            }
          }

          // クロロフィル基準線
          if (this.graphKindName == "日平均クロロフィルの推移") {
            for (let i = 2; i < chartArr.length; i++) {
              chartArr[i][4] = 2;
              chartArr[i][5] = 4;
            }
          }

          break;
        case "日平均溶存酸素の推移": {
          // 列順: 0=月日, 1=緑バンド, 2=黄バンド, 3=赤バンド, 4=グレーバンド, 5=日平均, 6=過去最高, 7=過去最低
          // 全行にバンド値を設定 (ComboのAreaが重ね描きされて背景帯を形成)
          // 緑バンドはどんなY軸上限でも上端まで塗りつぶせるよう十分大きな値を使用
          for (let i = 1; i < chartArr.length; i++) {
            chartArr[i][1] = 9999; // 緑
            chartArr[i][2] = 6.0;  // 黄
            chartArr[i][3] = 4.3;  // 赤
            chartArr[i][4] = 2.0;  // グレー
          }

          // グラフデータ設定(表示年1)
          if (summaryData[0].length > 0) {
            for (let row of summaryData[0]) {
              index = this.getDayOfYear(new Date(row['date']));
              if (index == 0) continue;
              chartArr[index][5] = row['btm_avg'];
            }
          }

          // グラフデータ設定(過去最高・過去最低)
          if (summaryData[2].length > 0) {
            for (let row of summaryData[2]) {
              if (row['date'] != '00/00') {
                dataTemp = row['date'].split('/');
                index = this.getDayOfYear(new Date(this.dispYear1, dataTemp[0] - 1, dataTemp[1]));
                if (index == 0) continue;
                dataTemp = [
                  Math.abs(row['total_max_min'][4]) != 999 ? row['total_max_min'][4] : 0,
                  Math.abs(row['total_max_min'][5]) != 999 ? row['total_max_min'][5] : 0,
                ];
                chartArr[index][6] = dataTemp[0];
                chartArr[index][7] = dataTemp[1];
              }
            }
          }

          // Y軸上限を動的に決定 (最小12、データの最大値が12を超えたらそれに合わせて拡張)
          let oxgMax = 12;
          for (let i = 1; i < chartArr.length; i++) {
            for (let c of [5, 6, 7]) {
              const v = chartArr[i][c];
              if (typeof v === 'number' && v > oxgMax) oxgMax = v;
            }
          }
          // 上端を少し余裕をもたせて整数に丸める
          oxgMax = Math.ceil(oxgMax);
          this.chartOptions.vAxis = {
            title: "[mg/L]",
            titleTextStyle: { italic: false },
            viewWindow: { min: 0, max: oxgMax },
          };

          break;
        }
        case "積算水温の表示":
          // グラフデータ設定(表示年1)
          if (summaryData[0].length > 0) {
            for (let row of summaryData[0]) {
              index = this.getDayOfYear(new Date(row['date']));
              if (index == 0) continue;
              chartArr[index][1] = this.getOptimalData(row);
            }
          }

          // グラフデータ設定(表示年2)
          if (summaryData[1].length > 0) {
            for (let row of summaryData[1]) {
              index = this.getDayOfYear(new Date(row['date']));
              if (index == 0) continue;
              chartArr[index][2] = this.getOptimalData(row);
            }
          }

          // 算出された平均値データを積算水温へ組み替える
          chartArr = this.recombinationIntegrated(chartArr);
          break;
        case "20℃超過日数の表示":
          // グラフデータ設定(表示年1)
          if (summaryData[0].length > 0) {
            for (let row of summaryData[0]) {
              index = this.getDayOfYear(new Date(row['date']));
              if (index == 0) continue;
              chartArr[index][1] = this.getOptimalData(row);
            }
          }

          // 算出された平均値データを20℃超過日数へ組み替える
          chartArr = this.recombinationArr(chartArr);
          break;
        default:
          break;
      }

      return chartArr;
    },
    /**
     * グラフデータを整形してGoogle Chartオブジェクトに設定
     */
    setGraphObject(chartArr) {

      const now = new DateWrapper(Date.now()).format;
      var chartDataSub = [];

      switch (this.graphKindName) {
        case "日平均水温の推移":
        case "日平均クロロフィルの推移":
        case "日平均塩分の推移":
        case "日平均溶存酸素の推移":
          // 初期は現在月分を表示
          if (this.selectMonthRsv != "0") {
            this.month = this.dispYear1.substring(0, 4) + "-" + this.selectMonthRsv;
          } else {
            this.month = this.dispYear1.substring(0, 4) + "-" + now.systemDate.substring(5, 7);
          }

          // 表示月を更新してonSelectCalenderMonth()を実行させる
          this.$refs.month_picker_graph.updateSearchMonth(
            this.dispYear1.substring(0, 4),
            this.month,
            true
          );

          break;
        case "積算水温の表示":
          // ヘッダ情報を設定
          chartDataSub.push(chartArr[0]);

          // 表示範囲を2/1(インデックス32)以降～8/31(インデックス244)にする
          for (let i = 32; i <= 244; i++) {
            // 表示年1、表示年2のどちらもうるう年でない場合は2月29日のデータをスキップする
            if (!this.isLeapYear(this.dispYear1) && !this.isLeapYear(this.dispYear2) && i == 60) {
              continue;
            }

            chartDataSub.push(chartArr[i]);
          }

          // データチェックしてグラフオブジェクトに表示データ設定
          this.chartData = this.checkArray(chartDataSub);

          break;
        case "20℃超過日数の表示":

          // 表示範囲は1月1日～12月31日
          for (let i = 0; i <= 366; i++) {
            // 表示年がうるう年でない場合は2月29日のデータをスキップする
            if (!this.isLeapYear(this.dispYear1) && i == 60) {
              continue;
            }

            chartDataSub.push(chartArr[i]);
          }

          // グラフオブジェクトに表示データ設定
          this.chartData = chartDataSub;

          break;
        default:
          break;
      }

      // 平均値の増減率を算出して詳細情報に表示
      this.setDetailData();

    },
    /**
     * 表層・中層・深層別で最適なパラメータを返却
     */
    getOptimalData(row) {
      switch (this.tabIndex) {
        case 1:
        default:
          return row['top_avg'];
        case 2:
          return row['mid_avg'];
        case 3:
          return row['btm_avg'];
      }
    },
    /**
     * 表層・中層・深層すべてを返す
     */
    getOptimalDataIntegrated(row) {
          return [row['top_avg'], row['mid_avg'], row['btm_avg']];
    },
    /**
     * 表層・中層・深層別で最適なパラメータを返却(過去最高、過去最低)
     */
    getOptimalAlltimeData(row) {
      var maxNum, minNum;

      switch (this.tabIndex) {
        case 1:
        default:
          maxNum = Math.abs(row['total_max_min'][0]) != 999 ? row['total_max_min'][0] : 0;
          minNum = Math.abs(row['total_max_min'][1]) != 999 ? row['total_max_min'][1] : 0;
          break;
        case 2:
          maxNum = Math.abs(row['total_max_min'][2]) != 999 ? row['total_max_min'][2] : 0;
          minNum = Math.abs(row['total_max_min'][3]) != 999 ? row['total_max_min'][3] : 0;
          break;
        case 3:
          maxNum = Math.abs(row['total_max_min'][4]) != 999 ? row['total_max_min'][4] : 0;
          minNum = Math.abs(row['total_max_min'][5]) != 999 ? row['total_max_min'][5] : 0;
          break;
      }

      return [maxNum, minNum];
    },
    /**
     * 表層・中層・深層別で最適なパラメータを返却(平年値)
     */
    getOptimalWatarTemp(row) {
      switch (this.tabIndex) {
        case 1:
        default:
          return row['avg'][0];
        case 2:
          return row['avg'][1];
        case 3:
          return row['avg'][2];
      }
    },
    /**
     * 算出された平均値データを積算水温のデータに組み替える
     */
    recombinationIntegrated(chartArr) {
      const transpose = a => a[0].map((_, c) => a.map(r => r[c]));

      let minTemp = [Infinity, Infinity];
      let indexTemp = [0, 0];
      let retArr = this.initChartData();

      // X軸、Y軸の入れ替え
      let transChartArr = transpose(chartArr);

      // 2月のインデックス範囲（32～60）のうち、最低水温のインデックスを算出し積算基準日とする
      for (let i= 0; i < minTemp.length; i++) {
        minTemp[i] = Math.min(...transChartArr[i+1].slice(32, 60));
        indexTemp[i] = transChartArr[i+1].indexOf(minTemp[i]);
      }

      for (let i = 0; i < indexTemp.length; i++) {
        // 表示年、前年の積算水温を算出、および基準線600℃を設定する
        for (let j = 2; j < chartArr.length; j++) {
          if (j > indexTemp[i]) {
            retArr[j][i+1] = retArr[j-1][i+1] +
              ((chartArr[j][i+1] - 10.0) < 0 ? 0 : (chartArr[j][i+1] - 10.0));
          }
          retArr[j][3] = 600;
        }

        // 表示年、前年の積算水温が700℃を初めて超えるインデックスを取得
        indexTemp[i] = retArr.findIndex(value => value[i+1] > 700);
 
        // インデックスが取得できなかった場合、最大値のインデックスを設定
        if (indexTemp[i] == -1) {
          indexTemp[i] = retArr.findIndex(value => value[i+1] == retArr[366][i+1]);
        }
      }

      // 表示年、前年のインデックスより後をnull埋めする
      for (let i = 0; i < indexTemp.length; i++) {
        for (let j = 1; j < chartArr.length; j++) {
          if (j > indexTemp[i]) retArr[j][i+1] = null;
        }
      }

      return retArr;
    },
    /**
     * 算出された平均値データを20℃超過日数のデータに組み替える
     */
    recombinationArr(chartArr) {
      let dayCount = 0;
      let retArr = this.initChartData();

      let date = new Date();
      let day;

      // 表示年の20℃超過日数を算出、および基準線150日を設定する
      for (let i = 1; i < chartArr.length; i++) {
        retArr[i][2] = 150;

        // 表示年がうるう年でない場合は2月29日のデータをスキップ
        // 翌日以降はスキップ(基準線は表示する)
        if ((!this.isLeapYear(this.dispYear1) && i == 60)) {
          continue;
        }

        day = new Date(this.dispYear1 + '-' + retArr[i][0].replace('月','-').replace('日',''));
        if (date < day) {
          retArr[i][1] = null;
        } else {
          if (chartArr[i][1] > 20.0) dayCount++;
          retArr[i][1] = dayCount;
        }
      }

      return retArr;
    },
    /**
     * 日付の通算日を返す
     * @param {日付} date
     * @returns 通算日
     */
    getDayOfYear(date = new Date()) {
      const timestamp1 = Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
      );
      const timestamp2 = Date.UTC(date.getFullYear(), 0, 0);

      const differenceInMilliseconds = timestamp1 - timestamp2;

      let differenceInDays = differenceInMilliseconds / 1000 / 60 / 60 / 24;

      // うるう年ではない場合、3月1日以降を＋１する
      if (!this.isLeapYear(date.getFullYear()) && differenceInDays >= 60) differenceInDays++;
      return differenceInDays;
    },
    /**
     * 与えられた西暦からうるう年かどうかを判定する
     * @param {西暦} year
     * @returns true/false
     */
    isLeapYear(year) {
      if ((year % 4 == 0) && (year % 100 != 0) || (year % 400 == 0)) {
          return true;
      } else {
          return false;
      }
    },
    /**
     * 詳細情報の設定
     */
    setDetailData() {
      var index = 0;
      var dispTemp = ["" , 0];
      this.annotateData = "";
      this.detailData = "";

      // 前日のデータを取得
      var date = new Date();
      date.setDate(date.getDate() - 1);
      index = this.getDayOfYear(date);
      var yesterday = this.chartDataRsv[index];

      dispTemp[0] = yesterday[0];
      switch (this.graphKindName) {
        case "日平均水温の推移":
          // 平年比を取得
          var yearOnyear = "--.-";
          if (yesterday[1] == null) {
            dispTemp[1] = "--.-";
          } else if (yesterday[1] != null && yesterday[2] != null) {
            dispTemp[1] = yesterday[1];
            if (yesterday[1] > yesterday[2]) {
              yearOnyear = "+" + (yesterday[1] - yesterday[2]).toFixed(1);
            } else if (yesterday[1] == yesterday[2]) {
              yearOnyear = "±0.0";
            } else {
              yearOnyear = (yesterday[1] - yesterday[2]).toFixed(1);
            }
          }

          // 詳細情報設定
          this.annotateData = "平年値：直近３ヶ年";
          this.detailData = dispTemp[0] + "現在 " +
            dispTemp[1] + "℃ (平年比 " + yearOnyear + "℃) ";
          break;
        case "20℃超過日数の表示":
          dispTemp[1] = yesterday[1];
          // 詳細情報設定
          this.detailData = date.getFullYear() + "年" + dispTemp[0] + "現在";
          break;
        default:
          break;
      }
    },
    /**
     * 表示区間全てデータが無いグラフに対して先頭データに0を設定し、残りをnullとする
     */
    checkArray(arr) {

      // 受け取った配列をディープコピーしておく（元の配列は変換させない）
      var copiedArr = JSON.parse(JSON.stringify(arr));
      var itemSize = arr[0].length;
      var isValid = new Array(itemSize).fill(false);

      // 初期値0の個所をnullに変換
      // 日平均水温の場合は3℃以下もnullに変換
      for (let d = 1; d < copiedArr.length; d++) {
        for (let i = 1; i < itemSize; i++) {
          copiedArr[d][i] = copiedArr[d][i] == 0 ? null : copiedArr[d][i];
          if (this.graphKindName == "日平均水温の推移") {
            copiedArr[d][i] = copiedArr[d][i] <= 3 ? null : copiedArr[d][i];
          }
        }
      }

      // 各グラフに対して0でもnullでもない日があればフラグを立てる
      for (let d = 1; d < copiedArr.length; d++) {
        for (let i = 1; i < itemSize; i++) {
          if (copiedArr[d][i] != 0 && copiedArr[d][i] != null) isValid[i] = true;
        }
      }

      // 各グラフのフラグをチェックしてfalse(表示区間全てnull)であれば先頭の日に0を設定する
      // 日平均水温の場合は平均値、過去最高、過去最低のいずれかの値を設定する
      for (let i = 1; i < itemSize; i++) {
        if (isValid[i] == false) {
          copiedArr[1].splice(i, 1, 0);
          if (this.graphKindName == "日平均水温の推移") {
            for (let j = 1; j < itemSize; j++) {
              if (copiedArr[1][j] != null && copiedArr[1][j] != 0) {
                copiedArr[1].splice(i, 1, copiedArr[1][j]);
                break;
              }
            }
          }
        }
      }

      return copiedArr;
    },
  },
  computed: {
    tabItems() {
      return this.getTabItems();
    },
  },
};
</script>

<style scoped>
.tab-item {
  width: 150px;
}
.tab-active {
  color: white !important;
  background-color: primary !important;
  margin-top: 4px;
  margin-bottom: 4px;
}
.detail-area {
  display: flex;
  align-items: flex-end;
}
</style>

